import { PageController } from '@client/components/_core/layout/PageController';
import { ComplianceAuditTemplateEvidenceTypeEdit } from '@client/components/compliance-audit-templates/ComplianceAuditTemplateEvidenceTypeEdit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/evidence-types/add',
)({
    staticData: {
        presentation: 'overlay',
        metadata: { title: 'New evidence type' },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <ComplianceAuditTemplateEvidenceTypeEdit
                complianceAuditTemplateId={Route.useParams().complianceAuditTemplateId}
                action={['add']}
            />
        </PageController>
    );
}
